enum CHALLENGE_STATUS {
  UNDEFINED,
  ON_GOING,
  COMPLETED,
  COMING_SOON
}

export default CHALLENGE_STATUS
